import React, { Component } from 'react';
import Button from '@mui/material/Button';
import { Grid, MenuItem } from '@mui/material';
import { connect } from 'react-redux';

import CustomSelect from '../CustomInputs/CustomSelect';
import api from '../../api';
import { onDownload, downloadFromBase64 } from '../../utils/download';
import notifSystem from '../../notifSystem';

class ArchiveReglementCentrDialog extends Component {
  state = {
    year: 2022,
  };

  handleClick = () => {
    this.props.callback();
  };

  getExport = (name) => {
    const { year } = this.state;

    api.reglements.custom(`getExport/${name}/${year}`)
      .get()
      .then(e => e.body().data())
      .then(({ file }) => {

        const outputFile = {
          contents: file,
          filename: `centralisation-${year}`,
        };

        if (name === 'csv') {
          onDownload(
            outputFile,
            name
          );
        } else if (name === 'pdf') {
          downloadFromBase64(
            outputFile,
            name
          );
        }
        notifSystem.success(`Fichier ${name}`.toUpperCase(),
          'Téléchargement réussi');
      }).catch((error) => {
        const errorMessage = error?.response?.data?.error || 'Erreur inconnue';
        notifSystem.error('ERREUR'.toUpperCase(), errorMessage);
      });
    this.props.callback();
  };

  render() {
    const { year } = this.state;
    return (
      <Grid container spacing={2} justifyContent="space-between">
        <CustomSelect
          grid
          xs={12}
          name="Année"
          value={year}
          path={[]}
          setData={(p, v) => this.setState({ year: v })}
        >
          {[2022, 2024].map((e) => (
            <MenuItem key={e} value={e}>
              {e}
            </MenuItem>
          ))}
        </CustomSelect>
        <Grid item xs={4}>
          <Button variant="outlined" onClick={() => this.getExport('csv')}>
            Export CSV
          </Button>
        </Grid>
        <Grid item xs={4}>
          <Button variant="outlined" onClick={() => this.getExport('pdf')}>
            Export PDF
          </Button>
        </Grid>
      </Grid>
    );
  }
}

const mapStateToProps = ({ dialog: { contentProps } }, props) => ({
  ...(contentProps || props),
});

export default connect(mapStateToProps)(ArchiveReglementCentrDialog);
